export const SET_ROOM = 'ROOM/SET_ROOM'
export const SET_SETTING = 'ROOM/SET_SETTING'
export const SET_ROOMS = 'ROOM/SET_ROOMS'
export const SET_CHAT = 'ROOM/SET_CHAT'
